"use client"

import { useState, useEffect } from "react"

function TaskForm({ onSubmit, onCancel, projects, editingTask, isEditing }) {
  const [taskName, setTaskName] = useState("")
  const [startDate, setStartDate] = useState("")
  const [description, setDescription] = useState("")
  const [taskType, setTaskType] = useState("Developer")
  const [project, setProject] = useState("")

  // Load task data when editing
  useEffect(() => {
    if (editingTask) {
      setTaskName(editingTask.name)
      setStartDate(editingTask.startDate)
      setDescription(editingTask.description)
      setTaskType(editingTask.taskType)
      setProject(editingTask.project)
    } else {
      clearForm()
    }
  }, [editingTask])

  // Clear form
  const clearForm = () => {
    setTaskName("")
    setStartDate("")
    setDescription("")
    setTaskType("Developer")
    setProject("")
  }

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault()

    const taskData = {
      name: taskName,
      startDate: startDate,
      description: description,
      taskType: taskType,
      project: project,
    }

    if (isEditing) {
      onSubmit({ ...editingTask, ...taskData })
    } else {
      onSubmit(taskData)
      clearForm()
    }
  }

  // Handle cancel
  const handleCancel = () => {
    clearForm()
    if (onCancel) {
      onCancel()
    }
  }

  return (
    <form onSubmit={handleSubmit} className="task-form">
      {/* Task Name */}
      <div className="form-group">
        <label>Task Name</label>
        <input
          type="text"
          placeholder="ENTER TASK NAME"
          value={taskName}
          onChange={(e) => setTaskName(e.target.value)}
          required
        />
      </div>

      {/* Task Start Date */}
      <div className="form-group">
        <label>Task Start Date</label>
        <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} required />
      </div>

      {/* Task Description */}
      <div className="form-group">
        <label>Task Description</label>
        <textarea
          placeholder="ENTER TASK DESCCRIPTION"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          required
        />
      </div>

      {/* Task Type */}
      <div className="form-group">
        <label>Task Type</label>
        <div className="radio-group">
          <label className="radio-label">
            <input
              type="radio"
              name="taskType"
              value="Developer"
              checked={taskType === "Developer"}
              onChange={(e) => setTaskType(e.target.value)}
            />
            Developer
          </label>
          <label className="radio-label">
            <input
              type="radio"
              name="taskType"
              value="Tester"
              checked={taskType === "Tester"}
              onChange={(e) => setTaskType(e.target.value)}
            />
            Tester
          </label>
        </div>
      </div>

      {/* Select Project */}
      <div className="form-group">
        <label>Select Project</label>
        <select value={project} onChange={(e) => setProject(e.target.value)} required>
          <option value="">Select Project</option>
          {projects.map((proj) => (
            <option key={proj} value={proj}>
              {proj}
            </option>
          ))}
        </select>
      </div>

      {/* Form Buttons */}
      {/* <div className="form-buttons">
         <button type="submit" className="btn-primary">
          {isEditing ? "Update" : "Add Task"}
        </button>

        {isEditing ? (
          <button type="button" onClick={handleCancel} className="btn-cancel">
            Cancel
          </button>
          
        ) : (
          <button type="button" onClick={clearForm} className="btn-secondary">
            Clear
          </button>
        )}
      </div> */}
      {/* Form Buttons */}
<div className="form-buttons">
  <button type="submit" className="btn-primary">
    {isEditing ? "Update" : "Add Task"}
  </button>

  {isEditing && (
    <>
      <button type="button" onClick={handleCancel} className="btn-cancel">
        Cancel
      </button>
      <button type="button" onClick={clearForm} className="btn-secondary">
        Clear
      </button>
    </>
  )}

  {!isEditing && (
    <button type="button" onClick={clearForm} className="btn-secondary">
      Clear
    </button>
  )}
</div>

    </form>
  )
}

export default TaskForm
